import React, { useState } from "react";
import styles from "../../../css/SaveMappingPopup.module.css";
import { toast } from "react-toastify";
import { ReactComponent as CloseIcon } from "../../../assets/icons/custModeLCloseIcon.svg";

const SaveMappingPopup = ({ onClose, companyId, onSave }) => {
  const [mappingName, setMappingName] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!mappingName.trim()) {
      toast.error("Please enter a mapping name");
      return;
    }
    
    try {
      setSaving(true);
      await onSave(mappingName.trim());
      onClose();
    } catch (err) {
      console.error("Save mapping error:", err);
     
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
       <div className={styles.header}>
          <div className={`${styles.title} ${styles.head}`}>Save Mapping</div>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon className={styles.closeIconLarge} />
          </button>
          
       </div> 

        <p className={styles.subTitle}>
          Save your label to column header mapping to instantly reuse going forward
        </p>

        <div className={styles.inputWrapper}>
          <label className={styles.label}>
            <span className={styles.required}>*</span> Mapping Name
          </label>
          <input
            type="text"
            className={styles.textInput}
            placeholder="Type Name"
            value={mappingName}
            onChange={(e) => setMappingName(e.target.value)}
          />
        </div>

        <div className={styles.footer}>
          <button className={styles.cancelBtn} onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button className={styles.saveBtn} onClick={handleSave} disabled={saving}>
            {saving ? "Saving..." : "Save Mapping"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveMappingPopup;